import {
  SidePanelComponents,
  SidePanelName,
  getSidePanelStyle,
} from '@features/ui-layout/components/SidePanel/SidePanelFactory';
import { useRouter } from 'next/router';

interface SidePanelContext {
  sidePanelName: SidePanelName;
  sidePanelWidth: string;
}

const useSidePanelContext = (): SidePanelContext | null => {
  const router = useRouter();
  const sidePanel = router.query.sidePanel as SidePanelName;

  if (!sidePanel) {
    return null;
  }

  return {
    sidePanelName: sidePanel,
    sidePanelWidth: getSidePanelStyle(SidePanelComponents[sidePanel].size).width,
  };
};

export default useSidePanelContext;
